import {
  createStyles, useMantineTheme, Drawer,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

type CustomModalProps = {
  opened: boolean;
  onClose: () => void;
  children?: JSX.Element | JSX.Element[];
  className?: any;
  closeOnClickOutside?:boolean
};

const useStyles = createStyles((theme) => ({
  cmodal: {
    bottom: 0,
    left: 0,
    '& .mantine-Drawer-drawer': {
      background: '#1B1D22',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      margin: '0px',
    },
    '& .mantine-Drawer-inner': {
      left: '0px',
    },
    '& .mantine-Drawer-overlay': {
      borderRadius: '12px',
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        borderRadius: 0,
      },
    },
    '& .mantine-Drawer-content': {
      borderRadius: '12px',
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
    },
    // '& .mantine-Modal-body': {
    //   height: '100%'
    // },
  },
}));

export const CustomModal = ({
  opened,
  onClose,
  children,
  className,
  closeOnClickOutside = true,
}: CustomModalProps) => {
  const theme = useMantineTheme();
  const { classes, cx } = useStyles();
  const matches = useMediaQuery(`(min-width: ${theme.breakpoints.xs})`);
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      position="bottom"
      className={cx(classes.cmodal, className)}
      withinPortal={!matches}
      lockScroll={false}
      closeOnClickOutside={closeOnClickOutside}
      closeOnEscape
      transitionProps={{ duration: 200, timingFunction: "linear" }}
    >
      {children}
    </Drawer>
  );
};

CustomModal.defaultProps = {
  children: null,
  className: null,
};

export default CustomModal;
